import React from "react";
import AuthContext from "../../context/AuthContext";
import FooterLoggedIn from "../ui/FooterLoggedIn";
import FooterLoggedOut from "../ui/FooterLoggedOut";
import logo from "../assets/logo-white.webp";
import logoIos from "../assets/logo-white.png";
import heart from "../assets/heart2.webp";
import heartIos from "../assets/heart2.png";
import "../CSS/footer.css";

export default function Footer() {
  return(
    <AuthContext.Consumer>
      {({ user }) => (
        <footer className = "Footer">
          <div className = "FooterLinksArea">
            <picture>
              <source srcSet={logo} type="image/webp" />
              <source srcSet={logoIos} type="image/png" />
              <img src={logoIos} alt="logo" height="150vmin" />
            </picture>
              <br/>
              <h3><span></span></h3>
              {user ? <FooterLoggedIn /> : <FooterLoggedOut />}
              <p className = "FooterCopyRight">© Copyright 2020 Madadgaar - All Rights Reserved.</p>
			    </div>         
            <div className = "FooterContact">
              <div>
                <h5>Our Vision</h5>
                <hr/>
                <p>Madadgaar was launched in 2020 to meet the changing</p> 
                <p>needs of blood donation.</p> 
                <p>Our founding vision remains simple: bringing blood donors</p> 
                <p>and recepients closer with a paperless process that is automated and transparent, 
                backed by exceptional reliability, ease of use,
                and personalized service.</p>
              </div>
            </div>
            <div className = "FooterAboutArea">
            <picture>
              <source srcSet={heart} type="image/webp" />
              <source srcSet={heartIos} type="image/png" />
              <img src={heartIos} alt="heart" height="120vmin" />
            </picture>
            </div>
        </footer>
    )}
  </AuthContext.Consumer>
  );
}